export const SET_DIALOG_MANAGER_STATE = 'SET_DIALOG_MANAGER_STATE'
export const CLOSE_DIALOG_MANAGER = 'CLOSE_DIALOG_MANAGER'
